import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { ProfileFormFields } from "./ProfileFormFields";
import { SignOutButton } from "./SignOutButton";
import { useProfileForm } from "./useProfileForm";

export function ProfileForm() {
  const { form, isLoading, onSubmit } = useProfileForm();

  if (isLoading) {
    return <div className="text-center">Loading profile...</div>;
  }

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        <ProfileFormFields form={form} />

        <div className="flex flex-col gap-4">
          <Button
            type="submit"
            className="w-full bg-grace-dark text-white hover:bg-grace-dark/90 transition-colors"
            disabled={isLoading}
          >
            Save Profile
          </Button>
          
          <SignOutButton disabled={isLoading} />
        </div>
      </form>
    </Form>
  );
}